import { Stack, Typography } from '@mui/material';
import { useAtomValue } from 'jotai';
import { useFormContext } from 'react-hook-form';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useState, useMemo } from 'react';

import { ErrorMessage } from '../../../../../../components/Form/FormComponents';
import { SearchInput } from '../../../../../../CoreComponents/base/SearchInput';
import { kpiActiveTemplatesListStateJ } from '../../../../../../services/state/KPI/KPITemplatesStateJ';
import { KPITemplateOption } from './KPITemplateOption';

/**@deprecated */
export function KPIAssignRequestModalSetTemplate() {
  const templatesList = useAtomValue(kpiActiveTemplatesListStateJ);
  const [searchTemplateValue, setSearchTemplateValue] = useState('');

  const methods = useFormContext();

  const selectedTemplatedId = methods.watch('templateUuid');

  const filteredTemplatesList = useMemo(() => {
    if (!templatesList) {
      return;
    }
    if (!searchTemplateValue) {
      return templatesList;
    }

    return templatesList.filter((template) =>
      template.name.toLowerCase().includes(searchTemplateValue.toLowerCase())
    );
  }, [searchTemplateValue, templatesList]);

  return (
    <Stack width='100%' gap='1rem' mt={'1rem'}>
      <Typography variant='body1'>Set Request Settings</Typography>
      <SearchInput
        onChange={setSearchTemplateValue}
        style={{ width: '100%' }}
        placeholder='Search template'
      />
      <Stack
        gap={'.75rem'}
        sx={{
          position: 'relative',
          left: '-.5rem',
          pl: '.5rem',
          pr: '.05rem',
          mr: '-.5rem',
          paddingTop: '.5rem',
          minHeight: '252px',
          maxHeight: '250px',
          overflowY: 'auto',
          overflowX: 'hidden',
        }}
      >
        {filteredTemplatesList?.map((template) => {
          return <KPITemplateOption key={template.id} template={template} />;
        })}
      </Stack>
      {!selectedTemplatedId && (
        <ErrorMessage>
          <Stack direction={'row'} alignItems={'center'} gap='.25rem'>
            <InfoOutlinedIcon sx={{ fontSize: '1.25rem' }} /> Please select related template
          </Stack>
        </ErrorMessage>
      )}
    </Stack>
  );
}
